'use client'

import LoginContainer from 'containers/Auth/Login'
import AuthRedirect from 'containers/AuthRedirect'

export default function Login() {
  return (
    <>
      <AuthRedirect />
      <LoginContainer />
    </>
  )
}
